export default "__VITE_ASSET__BRsSjAcd__"